import { Box, ListItemText, Typography } from "@mui/material";
import { countryFormatter, getFlagUrl } from "../../../../shared/utils";

export const createCountryRenderer =
  (mode: "option" | "chip") => (code: string) => {
    const countryDisplay = countryFormatter(code);
    const size = mode === "option" ? 40 : 20;
    if (!countryDisplay)
      return mode === "option" ? <ListItemText primary={code} /> : code;
    const text =
      mode === "option" ? (
        <ListItemText primary={countryDisplay.name} />
      ) : (
        <Typography variant="body2">{countryDisplay.name}</Typography>
      );
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: mode === "option" ? 1 : 0.75,
        }}
      >
        <img
          loading="lazy"
          width={size}
          src={countryDisplay.img}
          srcSet={getFlagUrl(code, size)}
          alt={`country flag for ${code}`}
        />
        {text}
      </Box>
    );
  };
